import { Fetch } from 'lib';
import { createTag } from 'services';

type RequestResponses = Awaited<ReturnType<typeof createTag>>;

type RequestParameters = {
  id: string;
};

type RequestBody = Parameters<typeof createTag>[number];

const updateTag = async (params: RequestParameters, body: RequestBody) =>
  await Fetch<RequestResponses, RequestParameters, RequestBody>({
    url: 'adminTag/updateTag',
    method: 'PUT',
    params,
    body,
  });

export { updateTag };
